import * as React from 'react';
import { useRef, useState,useMemo  } from 'react';
import { Stage, Layer} from 'react-konva';
import Button from '@mui/material/Button';
import { Sprayer } from './VisuComponents/Sprayer';
import { BedPlov } from './VisuComponents/BedPlov';
import { Streng } from './VisuComponents/StrengLaegger';
import { Planter } from './VisuComponents/Planter';
import { MachinePlough } from './VisuComponents/MachinePlough';
import { Irrigation } from './VisuComponents/Irrigation';
import { createUseStyles } from 'react-jss';
import StraightenIcon from '@mui/icons-material/Straighten';
import Measure from './VisuComponents/Measure';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { styled } from '@mui/material/styles';

// Existing styled components (StyledAccordion and BlueAccordionSummary) remain the same

// New styled component for AccordionDetails
const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: '#f5f5f5',
  borderTop: '1px solid rgba(0, 0, 0, 0.12)',
}));

// Styled components for metrics display
const MetricRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
  padding: '4px 0',
  '&:last-child': {
    marginBottom: 0,
  },
});

const MetricLabel = styled('span')({
  color: '#666',
  fontSize: '0.9rem',
  fontWeight: 500,
  marginRight: '30px',
});

const MetricValue = styled('span')({
  fontWeight: 'bold',
  color: '#333',
});



const useStyles = createUseStyles({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  btnToolbar: {
    position: 'absolute',
    zIndex: '10',
    marginTop: 5,
    marginLeft: 5,
    top: 0,
    left: 225,
  },
  btnDownload: {
    position: 'absolute',
    zIndex: '10',
    marginTop: 5,
    marginLeft: 5,
    top: 0,
    left: 0,
  },
  btnMeasure: {
    position: 'absolute',
    zIndex: '10',
    marginTop: 5,
    marginLeft: 5,
    top: 0,
    left: 130,
  },
  summaryTile: {
    position: 'absolute',
    zIndex: '10',
    marginTop: 5,
    marginLeft: 5,    
    top: 0,
    left: 225,
    // width: 400    
  },
  // summaryHeader: {
  //   padding: '12px 16px',
  //   borderBottom: '1px solid #e0e0e0',
  //   display: 'flex',
  //   height: '100%',
  //   justifyContent: 'space-between',
  //   alignItems: 'center',
  //   cursor: 'pointer',
  // },
  // summaryContent: {
  //   padding: '16px',
  // },
  metricRow: {
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  metricLabel: {
    color: '#666',
    fontSize: '0.9rem',
  },
  metricValue: {
    fontWeight: 'bold',
  }
})



export default function Content({ width, height, drawing }) {

  const stageRef = useRef(null);
  const [pos, setPos] = useState({ x: 50, y: 400 });
  const [scale, setScale] = useState({ x: 0.09, y: 0.09 });   
  const [measureState, setMeasureState] = useState({active:false, state:0, x1:0,y1:0, x2:0,y2:0})
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [exportFormat, setExportFormat] = useState('png');
  const [exportResolution, setExportResolution] = useState(1);
  const [exportEntireStage, setExportEntireStage] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);  
  const [expandedPanel, setExpandedPanel] = useState(false);
  const [transparentCount, setTransparentCount] = useState(0);

  const handleAccordionChange = () => (event, isExpanded) => {
  setExpandedPanel(isExpanded);
};

  let lastCenter = null;
  let lastDist = 0;
  const classes = useStyles();

  // const metrics = {
  //   rowsPerHectare: 2000, // Example value
  //   lossesPercentage: 2.5, // Example value
  //   totalArea: 10.5, // Example value in hectares
  //   averageYield: 35.2, // Example value in tons/ha
  // };


  // Compute metrics based on the drawing prop.
  // Replace the example calculations with your actual formulas.
  const metrics = useMemo(() => {
    // Example calculations:

    const beds = Math.ceil(drawing.sprayerWidth * drawing.sprayers / drawing.bedWidth);
    const bedsPrSprayerWidth = drawing.sprayerWidth / drawing.bedWidth
    const rowsPrSprayerWidth = drawing.rowsPrBed * bedsPrSprayerWidth
    const rowsPrMeter = rowsPrSprayerWidth / (drawing.sprayerWidth / 1000.0)
    const meterRowPrHa = rowsPrMeter * 100 * 100
    const lossesOnDrawing = transparentCount / (beds * drawing.rowsPrBed) * 100
    const meterRowPrHaWithLossed = meterRowPrHa * (1 - lossesOnDrawing / 100)
    const BedToBedRowDistance = drawing.bedWidth - (drawing.rowsPrBed - 1) * drawing.rowDistance


    return {
      bedsPrSprayerWidth,
      rowsPrSprayerWidth,
      meterRowPrHa,
      meterRowPrHaWithLossed,
      lossesOnDrawing,
      beds,
      BedToBedRowDistance
    };
  }, [drawing,transparentCount]);

  const handleExport = async () => {
    const stage = stageRef.current;
    if (!stage) return;
  
    try {
      // Get layer and content bounds
      const layer = stage.findOne('Layer');
      const bounds = layer.getClientRect();

      console.log(bounds)
  
      // Calculate content dimensions (in stage’s coordinate space)
      const contentWidth = Math.abs(bounds.width) 
      const contentHeight = Math.abs(bounds.height)
  
      // Compute desired export dimensions
      let desiredWidth, desiredHeight;
      if (exportEntireStage) {
        desiredWidth = contentWidth * exportResolution;
        desiredHeight = contentHeight * exportResolution;
      } else {
        desiredWidth = width * exportResolution;
        desiredHeight = height * exportResolution;
      }
  
      console.log(desiredWidth)
      console.log(desiredHeight)
      // Define a safe maximum canvas dimension to avoid browser limits
      const MAX_CANVAS_DIMENSION = 32767;
      let scaleFactor = 1;
      if (desiredWidth > MAX_CANVAS_DIMENSION || desiredHeight > MAX_CANVAS_DIMENSION) {
        // Scale down uniformly so both dimensions fit within limits
        scaleFactor = Math.min(
          MAX_CANVAS_DIMENSION / desiredWidth,
          MAX_CANVAS_DIMENSION / desiredHeight
        );
        console.warn(
          `Export resolution adjusted by scale factor ${scaleFactor.toFixed(2)} to fit browser limits.`
        );
      }
  
      // Final canvas dimensions after applying scale factor
      const finalCanvasWidth = Math.floor(desiredWidth * scaleFactor);
      const finalCanvasHeight = Math.floor(desiredHeight * scaleFactor);
      console.log(finalCanvasWidth)
      console.log(finalCanvasHeight)
      // Create final canvas
      const finalCanvas = document.createElement('canvas');
      finalCanvas.width = finalCanvasWidth;
      finalCanvas.height = finalCanvasHeight;
      const finalCtx = finalCanvas.getContext('2d');
  
      // Fill background with white
      finalCtx.fillStyle = 'white';
      finalCtx.fillRect(0, 0, finalCanvasWidth, finalCanvasHeight);
  
      // Set export options, adjusting the pixelRatio with our scale factor
      const exportOptions = {
        pixelRatio: exportResolution * scaleFactor,
        mimeType: `image/${exportFormat}`,
      };
  
      // Download helper using toBlob
      const exportAndDownload = () => {
        return new Promise((resolve, reject) => {
          finalCanvas.toBlob((blob) => {
            if (blob && blob.size > 0) {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `visualisering.${exportFormat}`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              resolve();
            } else {
              console.warn('Blob creation failed, falling back to DataURL');
              const dataUrl = finalCanvas.toDataURL(`image/${exportFormat}`);
              const link = document.createElement('a');
              link.href = dataUrl;
              link.download = `visualisering.${exportFormat}`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              resolve();
            }
          }, `image/${exportFormat}`);
        });
      };
  
      // Tiling logic for exporting the entire stage
      if (exportEntireStage) {
        // Define the base maximum tile size (in unscaled exported coordinates)
       
            const tileOptions = {
              ...exportOptions,
              // Adjust starting position based on layer bounds and tile index
              x: (bounds.x ),
              y: (bounds.y ),
              width: contentWidth,
              height: contentHeight,
            };
            
            console.log(tileOptions)
            // Export tile as data URL
            const tileDataUrl = stage.toDataURL(tileOptions);
  
            // Create image from the tile
            const tileImage = await new Promise((resolve, reject) => {
              const img = new window.Image();
              img.onload = () => resolve(img);
              img.onerror = reject;
              img.src = tileDataUrl;
            });  
           
            finalCtx.drawImage(tileImage, 0, 0, finalCanvasWidth, finalCanvasHeight);  
      
                 
        } else {
        console.log(exportOptions)
        // For the visible area export, simply render the stage
        const dataUrl = stage.toDataURL(exportOptions);
        const img = await new Promise((resolve, reject) => {
          const image = new window.Image();
          image.onload = () => resolve(image);
          image.onerror = reject;
          image.src = dataUrl;
        });
        // Draw the image scaled to our final canvas dimensions
        finalCtx.drawImage(img, 0, 0, finalCanvasWidth, finalCanvasHeight);
      }
  
      await exportAndDownload();
      setExportDialogOpen(false);
      setExportProgress(0);
    } catch (error) {
      console.error('Export failed:', error);
      // Fallback export
      try {
        const dataUrl = stage.toDataURL();
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = `visualisering.${exportFormat}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (fallbackError) {
        console.error('Fallback export also failed:', fallbackError);
        alert('Image export failed. Please try again.');
      }
      setExportProgress(0);
    }
  };

  const downloadURI = (uri, name) => {
    var link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const onSave = () => {
    // var dataURL = stageRef.current.toDataURL({ pixelRatio: 4 });
    // console.log(dataURL)
    // downloadURI(dataURL, 'visualisering.png')
    setExportDialogOpen(true);
  }


  const onWheel = (e) => {
    var scaleBy = 1.1;
    // stop default scrolling
    e.evt.preventDefault();

    const stage = stageRef.current;
    if (stage === null) {
      console.log(" Stage ref is null")
      return
    }
    var oldScale = stageRef.current.attrs.scaleX;
    var pointer = stageRef.current.getPointerPosition();

    var mousePointTo = {
      x: (pointer.x - stageRef.current.attrs.x) / oldScale,
      y: (pointer.y - stageRef.current.attrs.y) / oldScale,
    };

    // how to scale? Zoom in? Or zoom out?
    let direction = e.evt.deltaY > 0 ? -1 : 1;

    // when we zoom on trackpad, e.evt.ctrlKey is true
    // in that case lets revert direction
    if (e.evt.ctrlKey) {
      direction = -direction;
    }

    var newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

    setScale({ x: newScale, y: newScale });

    var newPos = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };
    setPos(newPos);
  }

  function isTouchEnabled() { 
    return ( 'ontouchstart' in window ) ||  
           ( navigator.maxTouchPoints > 0 ) ||  
           ( navigator.msMaxTouchPoints > 0 ); 
  } 

  function handleMeasureToggle(){
    setMeasureState({...measureState, active: !measureState.active, state: 0})
    
  }

  function handleMouseMove(e){
    if(measureState.state === 1){
      var pointerPos = stageRef.current.getPointerPosition()
      var x = (pointerPos.x - stageRef.current.attrs.x) / stageRef.current.attrs.scaleX
      var y = (pointerPos.y - stageRef.current.attrs.y) / stageRef.current.attrs.scaleX
      setMeasureState({...measureState, x2: x , y2: y})
    }

  }

  function onStageClick(e){
    
    
    if(measureState.active === false){
      return;
    }
    var pointerPos = stageRef.current.getPointerPosition()
    var x = (pointerPos.x - stageRef.current.attrs.x) / stageRef.current.attrs.scaleX
    var y = (pointerPos.y - stageRef.current.attrs.y) / stageRef.current.attrs.scaleX
    if(measureState.state === 0){
        setMeasureState({...measureState, x1: x, y1: y, x2: x, y2: y, state: 1})
    } else if(measureState.state === 1){
      setMeasureState({...measureState, x2: x, y2: y, state: 2})
    } else if(measureState.state === 2){
      setMeasureState({...measureState, state: 0})
    }
  }

  const onTouchStart = (e) => {
    e.evt.preventDefault();
    const stage = stageRef.current;
    if (!stage) return;

    const touches = e.evt.touches;
    if (touches.length === 1) {
      // Single touch - start dragging
      const touch = touches[0];
      lastCenter = {
        x: touch.clientX,
        y: touch.clientY,
      };
    } else if (touches.length === 2) {
      // Two touches - start pinch
      const touch1 = touches[0];
      const touch2 = touches[1];
      lastCenter = getCenter(touch1, touch2);
      lastDist = getDistance(touch1, touch2);
    }
  };

  const onTouchMove = (e) => {
    e.evt.preventDefault();
    const stage = stageRef.current;
    if (!stage) return;

    const touches = e.evt.touches;
    if (touches.length === 1) {
      // Single touch - drag
      const touch = touches[0];
      const newCenter = {
        x: touch.clientX,
        y: touch.clientY,
      };

      if (!lastCenter) {
        lastCenter = newCenter;
        return;
      }

      const dx = newCenter.x - lastCenter.x;
      const dy = newCenter.y - lastCenter.y;

      const newPos = {
        x: stage.x() + dx,
        y: stage.y() + dy,
      };

      setPos(newPos);
      lastCenter = newCenter;
    } else if (touches.length === 2) {
      // Two touches - pinch
      const touch1 = touches[0];
      const touch2 = touches[1];
      const newCenter = getCenter(touch1, touch2);
      const newDist = getDistance(touch1, touch2);

      if (!lastCenter || !lastDist) {
        lastCenter = newCenter;
        lastDist = newDist;
        return;
      }

      // Calculate scale factor
      const scale = stage.scaleX() * (newDist / lastDist);
      setScale({ x: scale, y: scale });

      // Calculate new position
      const dx = newCenter.x - lastCenter.x;
      const dy = newCenter.y - lastCenter.y;

      const pointTo = {
        x: (newCenter.x - stage.x()) / stage.scaleX(),
        y: (newCenter.y - stage.y()) / stage.scaleY(),
      };

      const newPos = {
        x: newCenter.x - pointTo.x * scale + dx,
        y: newCenter.y - pointTo.y * scale + dy,
      };

      setPos(newPos);
      lastCenter = newCenter;
      lastDist = newDist;
    }
  };

  const onTouchEnd = () => {
    lastCenter = null;
    lastDist = 0;
  };

  const getCenter = (p1, p2) => {
    return {
      x: (p1.clientX + p2.clientX) / 2,
      y: (p1.clientY + p2.clientY) / 2,
    };
  };

  const getDistance = (p1, p2) => {
    return Math.sqrt(
      Math.pow(p2.clientX - p1.clientX, 2) +
      Math.pow(p2.clientY - p1.clientY, 2)
    );
  };
  

  
  const furrowWidth = 1400
  return (

    <>
     <div className={classes.btnDownload}>
        <Button onClick={onSave} variant="contained" className={classes.btn}>
          Save Image
        </Button>
        </div>
        <Dialog open={exportDialogOpen} onClose={() => setExportDialogOpen(false)}>
        <DialogTitle>Export Options</DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Format</InputLabel>
            <Select
              value={exportFormat}
              label="Format"
              onChange={(e) => setExportFormat(e.target.value)}
            >
              <MenuItem value="png">PNG</MenuItem>
              <MenuItem value="jpeg">JPEG</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Export Area</InputLabel>
            <Select
              value={exportEntireStage}
              label="Export Area"
              onChange={(e) => setExportEntireStage(e.target.value === 'true')}
            >
              <MenuItem value="false">Visible Area</MenuItem>
              <MenuItem value="true">Entire Stage</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Resolution</InputLabel>
            <Select
              value={exportResolution}
              label="Resolution"
              onChange={(e) => setExportResolution(e.target.value)}
            >
              <MenuItem value={1}>1x (Standard)</MenuItem>
              <MenuItem value={2}>2x</MenuItem>
              <MenuItem value={3}>3x</MenuItem>
              <MenuItem value={4}>4x</MenuItem>
              <MenuItem value={5}>5x</MenuItem>
              <MenuItem value={6}>6x</MenuItem>
              <MenuItem value={8}>8x</MenuItem>
            </Select>
          </FormControl>

          {exportProgress > 0 && (
            <div style={{ marginTop: 16, textAlign: 'center' }}>
              Exporting: {exportProgress}%
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setExportDialogOpen(false)}>Cancel</Button>
          <Button 
            onClick={handleExport} 
            variant="contained" 
            disabled={exportProgress > 0}
          >
            Export
          </Button>
        </DialogActions>
      </Dialog>
        <div className={classes.btnMeasure}>
          <Button variant={measureState.active ? "contained" : "outlined"}  endIcon={<StraightenIcon/>} onClick={handleMeasureToggle}>
             Mål
          </Button>
        </div>   
      <div className={classes.summaryTile}>
     <Accordion 
             expanded={expandedPanel}
             onChange={handleAccordionChange()}
           >
      <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Oversigt</Typography>
        </AccordionSummary>
        <StyledAccordionDetails>
            <div style={{ width: '100%' }}>
              <MetricRow>
                <MetricLabel>Meter række pr. hektar (m)</MetricLabel>
                <MetricValue>{metrics.meterRowPrHa.toFixed(1)} / {metrics.meterRowPrHaWithLossed.toFixed(1)}</MetricValue>
              </MetricRow>
              <MetricRow>
                <MetricLabel>Tab på tegning (%)</MetricLabel>
                <MetricValue>{metrics.lossesOnDrawing.toFixed(2)}%</MetricValue>
              </MetricRow>
              <MetricRow>
                <MetricLabel>Bed pr. sprøjtebredde ({(drawing.sprayerWidth / 1000).toFixed(2)}m)</MetricLabel>
                <MetricValue>{metrics.bedsPrSprayerWidth.toFixed(2)}</MetricValue>
              </MetricRow>
              <MetricRow>
                <MetricLabel>Rækker pr. sprøjtebredde ({(drawing.sprayerWidth / 1000).toFixed(2)}m)</MetricLabel>
                <MetricValue>{metrics.rowsPrSprayerWidth.toFixed(2)}</MetricValue>
              </MetricRow>
              <MetricRow>
                <MetricLabel>Bed til Bed rækkeafstand (cm)</MetricLabel>
                <MetricValue>{(metrics.BedToBedRowDistance/10).toFixed(1)}</MetricValue>
              </MetricRow>
            </div>
          </StyledAccordionDetails>
      </Accordion>
      </div>


        
    <Stage 
      width={width}
      height={height} 
      draggable={!isTouchEnabled()} 
      onWheel={onWheel} 
      onMouseMove={handleMouseMove} 
      onClick={onStageClick} 
      onTouchStart={onTouchStart} 
      onTouchMove={onTouchMove} 
      onTouchEnd={onTouchEnd} 
      x={pos.x} 
      y={pos.y} 
      scale={scale} 
      ref={stageRef}>
      <Layer>
         

        <BedPlov x={0} y={0} numberSize={drawing.numberSize} seperationLineWidth={drawing.seperationLineWidth} width={drawing.bedWidth} height={500} nr={metrics.beds} furrows={drawing.ploughFurrow} offset={drawing.offset} />
        <Streng x={0} y={2000} numberSize={drawing.numberSize} width={drawing.bedWidth} height={500} nr={metrics.beds} />
        <Planter x={0} 
        y={4000} 
        seperationLineWidth={drawing.seperationLineWidth}
        numberSize={drawing.numberSize}
        width={drawing.bedWidth}
         height={500} 
         nrbeds={metrics.beds} 
         widths={drawing.rowPattern} 
         planterRows={drawing.planterRows} 
         rowsPrBed={drawing.rowsPrBed} 
         firstRows={drawing.firstRows} 
         rowDistance={drawing.rowDistance} 
         onTransparentChange={setTransparentCount}
         />
        {Array(drawing.sprayers).fill().map((e, i) => {

          return  <Sprayer seperationLineWidth={drawing.seperationLineWidth} x={i*drawing.sprayerWidth} y={6000} width={drawing.sprayerWidth} height={500} tire_width={drawing.tireWidth} track_width={drawing.tractorWidth} boom_thickness={drawing.boomThickness} key={i} />
        })}
        {Array(drawing.irrigators).fill().map((e, i) => {

        return  <Irrigation seperationLineWidth={drawing.seperationLineWidth} x={i*drawing.irrigationWidth} y={7000} width={drawing.irrigationWidth} height={500} tire_width={drawing.irrigationTireWidth} track_width={drawing.irrigationAxleWidth} boom_thickness={drawing.boomThickness} key={i} />
        })}

        <MachinePlough x = {-furrowWidth/2 + (drawing.offset * drawing.bedWidth)} y={-850} furrowWidth={furrowWidth} bedWidth={drawing.bedWidth}  furrowHeight={800}  furrows={drawing.ploughFurrow}/>
        {measureState.state !== 0 && <Measure measureLineWidth={drawing.measureLineWidth} numberSize={drawing.numberSize} measureState={measureState}/>}
      </Layer>
    </Stage>
    </>
  );
}
